<template>
    <section>
        <page-header>
            <slot slot="title">{{$t('fast_order.title')}}</slot>
            <slot slot="description">
                <p v-html="$t('fast_order.description')"></p>
                <button @click.prevent="addToCart" :disabled="btnCartDisabled" class="c-button c-button--alpha">{{$t('fast_order.add_to_shopping_cart')}}</button>
            </slot>
        </page-header>

        <div class="o-wrapper o-wrapper--center">
            <section class="o-page-row--huge">
                <!-- FASTORDERS Search API -->
                <div class="fastorder__search">
                    <div v-if="FastOrderProducts.length > 1" class="u-text-align-right" style="margin-top: -40px; margin-bottom: 10px;">
                        <button @click.prevent="clearProducts" class="c-button c-button--outline c-button--tiny">{{$t('fast_order.remove_all_products')}}</button>
                    </div>
                    <v-product-search
                            :can-add-group="false"
                            :addBranchFilter="true"
                            :includePreOrderProducts="isImpersonated"
                            branchRestriction="sell"
                            @add-product-to-sheet="addProductToOrder">
                    </v-product-search>
                </div>

                <!-- CUSTOMER ProductVariationLine-->
                <div class="u-margin-bottom">
                    <v-product-variation-line v-for="product in FastOrderProducts"
                                              :product="product"
                                              :key="product.Id">
                    </v-product-variation-line>
                </div>

                <!-- EMPTY STATE FastOrderProducts -->
                <div class="u-font-large u-text-align-center u-padding"
                     v-if="FastOrderProducts.length === 0">
                    {{ $t('preorder_fiche.no_products_added') }}<br>
                    <span class="u-font-default">{{ $t('preorder_fiche.use_search') }}</span>
                </div>
            </section>
        </div>

    </section>
</template>

<script>
    import debounce from 'lodash/debounce'
    import VLoading from '@/components/Loading'
    import PageTitle from '@/components/common/PageTitle';
    import PageHeader from '@/components/common/PageHeader'
    import VProductSearch from '@/components/form/productSearch/ProductSearch'
    import VProductVariationLine from '@/components/product/customer/ProductVariationLine'

    export default {
        components: {
            PageTitle,
            PageHeader,
            VLoading,
            VProductSearch,
            VProductVariationLine
        },
        data() {
          return {
              FastOrders: []
          }
        },
        computed: {
            FastOrderProducts() {
                return this.$store.getters.FastOrderProducts;
            },
            btnCartDisabled() {
                let tooMuch = true;

                this.FastOrderProducts.forEach(product => {
                    product.Variants.forEach(variant => {
                        if (variant.Amount > variant.Stock) tooMuch = false;
                    })
                });

                return !tooMuch;
            },
            isImpersonated() {
                return this.$store.getters.isImpersonated;
            }
        },
        methods: {
            addProductToOrder(productId) {
                this.$store.dispatch('getFastOrderProduct', productId).then((product) => {
                    this.$notify({
                        group: 'global',
                        title: this.$t('fast_order.product_added', {'product_name': product.Name}),
                        type: 'success',
                        duration: 3000
                    });
                }).catch((product) => {
                    this.$notify({
                        group: 'global',
                        title: this.$t('fast_order.product_already_added', {'product_name': product.Name}),
                        type: 'info',
                        duration: 3000
                    });
                });
            },
            addToCart() {
                let products = [];
                this.FastOrderProducts.forEach(product => {
                    product.Variants.forEach(variantline => {
                        variantline.forEach(variant => {
                            if (variant && variant.Amount > 0){
                                products.push({ amount: variant.Amount, productVariantId: variant.Id, productId: product.Id });
                            }
                        });
                    });
                });

                if (products.length) {
                    this.$store.dispatch("addProductsToBasket",{
                        products: products,
                        isDropshipment: false
                    }).then(() => {
                        this.$store.dispatch('deleteFastOrderProducts');
                        this.$store.dispatch("getBasket");
                        this.$notify({
                            group: 'global',
                            title: 'Uw producten zijn verzonden naar de winkelwagen.',
                            type: 'success',
                            duration: 3000
                        });
                    });
                } else {
                    this.$notify({
                        group: 'global',
                        title: 'U heeft geen aantallen ingevuld van de geselecteerde producten.',
                        type: 'info',
                        duration: 4000
                    });
                }

            },
            clearProducts() {
                const confirm = window.confirm('Weet u zeker dat u alle producten uit de lijst wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden!')
                if (confirm) {
                    this.$store.dispatch('deleteFastOrderProducts');
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .fastorder__search .c-customer-search {
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/customer/shop/FastOrder.vue